/**
 * ToastHost — renderiza as notificações in-app emitidas por utils/toast.js.
 * Montado uma única vez em index.js. Canto superior direito, auto-dismiss.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { subscribeToasts } from '../utils/toast.js';
import Icon from './Icon.js';

const STYLES = {
  success: { color: 'var(--accent-green)', bg: 'rgba(52,211,153,0.12)', border: 'rgba(52,211,153,0.4)', icon: 'check' },
  error:   { color: '#fda4af',             bg: 'rgba(251,91,107,0.12)', border: 'rgba(251,91,107,0.4)', icon: 'x' },
  warning: { color: 'var(--accent-gold)',  bg: 'rgba(251,191,36,0.12)', border: 'rgba(251,191,36,0.4)', icon: 'bell' },
  info:    { color: 'var(--accent-cyan)',  bg: 'rgba(34,211,238,0.12)', border: 'rgba(34,211,238,0.4)', icon: 'bell' },
};

const ToastHost = () => {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => setToasts((t) => t.filter((x) => x.id !== id)), []);

  useEffect(() => subscribeToasts((toastObj) => {
    setToasts((t) => [...t, toastObj]);
    if (toastObj.duration > 0) {
      setTimeout(() => remove(toastObj.id), toastObj.duration);
    }
  }), [remove]);

  return (
    <div style={{
      position: 'fixed', top: '18px', right: '18px', zIndex: 4000,
      display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: 'min(92vw, 380px)',
      pointerEvents: 'none',
    }} aria-live="polite">
      {toasts.map((t) => {
        const s = STYLES[t.type] || STYLES.info;
        return (
          <div
            key={t.id}
            onClick={() => remove(t.id)}
            style={{
              pointerEvents: 'auto', cursor: 'pointer',
              display: 'flex', alignItems: 'flex-start', gap: '11px',
              padding: '13px 15px', borderRadius: 'var(--radius-md)',
              // Fundo do tema (branco no claro, escuro no escuro) — antes era navy
              // fixo, o que tornava o texto ilegível no tema claro (escuro/escuro).
              background: 'var(--modal-bg, var(--bg-card))',
              border: `1px solid ${s.border}`,
              boxShadow: 'var(--shadow-elevated)',
              backdropFilter: 'saturate(160%) blur(12px)',
              animation: 'toastIn 0.32s cubic-bezier(0.16,1,0.3,1)',
            }}
          >
            <span style={{
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              width: '28px', height: '28px', borderRadius: '9px', flexShrink: 0,
              background: s.bg, color: s.color,
            }}>
              <Icon name={s.icon} size={16} color={s.color} />
            </span>
            <span style={{ flex: 1, fontSize: '0.9rem', lineHeight: 1.5, color: 'var(--text-primary)' }}>
              {t.message}
            </span>
          </div>
        );
      })}
      <style>{`@keyframes toastIn { from { opacity: 0; transform: translateX(40px); } to { opacity: 1; transform: translateX(0); } }`}</style>
    </div>
  );
};

export default ToastHost;
